import { atom } from "recoil";
import { IContact } from "../types/Contact";

export const BillingAddressControlCollapseAtom = atom<boolean>({
  key: "BillingAddressControlCollapseAtom",
  default: false,
});

export const ShippingAddressControlCollapseAtom = atom<boolean>({
  key: "ShippingAddressControlCollapseAtom",
  default: false,
});

export enum ContactsDetailsEnum {
  GENERAL = "GENERAL",
  ANNOTATIONS = "ANNOTATIONS",
  TAG = "TAG",
}

export const CurrentCRMSelectedTab = atom<string>({
  key: "CurrentCRMSelectedTab",
  default: ContactsDetailsEnum.GENERAL,
});

export interface CrmFormStateProps {
  firstName?: string;
  lastName?: string;
  phone?: string;
  email: string;

  testimonial?: string;

  customFields?: {
    [key: string]: string;
  };

  billingStreet1?: string;
  billingStreet2?: string;
  billingCity?: string;
  billingCountry?: string;
  billingState?: string;
  billingPostalCode?: string;
  billingPhoneCountryCode?: string;
  billingPhone?: string;
  billingFullAddress?: string;
  billingPlaceId?: string;
  billingStreetNumber?: string;

  shippingStreet1?: string;
  shippingStreet2?: string;
  shippingCity?: string;
  shippingCountry?: string;
  shippingState?: string;
  shippingPostalCode?: string;
  shippingPhoneCountryCode?: string;
  shippingPhone?: string;
  shippingFullAddress?: string;
  shippingPlaceId?: string;
  shippingStreetNumber?: string;
}
interface ClientLocationGeometryProps {
  lat?: number;
  lng?: number;
}
export const ClientLocationGeometryAtom = atom<ClientLocationGeometryProps>({
  key: "ClientLocationGeometryAtom",
  default: { lat: undefined, lng: undefined },
});

export const CrmFormStateAtom = atom<CrmFormStateProps>({
  key: "CrmFormStateAtom",
  default: { email: "" },
});

export const IsEditingOneItemAtom = atom<{
  edit: boolean;
  field: string;
}>({
  key: "IsEditingOneItemAtom",
  default: {
    edit: false,
    field: "",
  },
});

export const ContactsAtom = atom<IContact[]>({
  key: "Contacts",
  default: [],
});

export const ContactsTotalAtom = atom<number>({
  key: "ContactsTotal",
  default: 0,
});

export const FilteredContactsAtom = atom<IContact[]>({
  key: "FilteredContacts",
  default: [],
});
